import React from 'react'

/**
 * styled-components 4 has no transient props: `styled(AntdButton)` hands
 * `$toneStyles` etc. to antd, which spreads them onto the DOM element and
 * React warns. Wrap the antd component so styles still see `$` props but the
 * component (and DOM) never does: `styled(stripTransientProps(Button))`.
 */
export const omitTransientProps = props => {
  const clean = {}
  Object.keys(props || {}).forEach(key => {
    if (key.charAt(0) !== '$') clean[key] = props[key]
  })
  return clean
}

const REACT_STATICS = [
  'propTypes',
  'defaultProps',
  'displayName',
  'contextType',
  'contextTypes',
  'childContextTypes',
  'getDerivedStateFromProps',
  'getDerivedStateFromError',
  'getDefaultProps',
]

export const stripTransientProps = Component => {
  const Stripped = React.forwardRef((props, ref) =>
    React.createElement(Component, { ...omitTransientProps(props), ref }),
  )
  Stripped.displayName = `StripTransient(${
    Component.displayName || Component.name || 'Component'
  })`
  // antd Tooltip reads `__ANT_BUTTON` to wrap disabled buttons.
  Object.keys(Component).forEach(key => {
    if (!REACT_STATICS.includes(key) && !(key in Stripped)) {
      Stripped[key] = Component[key]
    }
  })
  return Stripped
}

export default stripTransientProps
